// src/contexts/PageContext.js
import React, { createContext, useState, useEffect } from "react";

export const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState("");

  useEffect(() => {
    if (pageTitle) {
      document.title = pageTitle;
    } else if (localStorage.getItem("pageTitle")) {
      document.title = localStorage.getItem("pageTitle");
    }
  }, [pageTitle]);

  return (
    <PageContext.Provider value={{ pageTitle, setPageTitle }}>
      {children}
    </PageContext.Provider>
  );
};
